export const TEST_ID = 'eventTypeSelector';

export const SERVICE_EVENT_TYPES = ['replaced', 'serviced', 'inspected', 'calibrated'] as const;
